import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { NewDashboardForm } from "@/components/reporting/dashboards/new-dashboard-form";
import { useAppStore } from "@/store";

export const Route = createFileRoute("/_authenticated/reports/dashboards/new")({
  component: NewReportDashboardRoute,
});

/**
 * A new dashboard. The form performs the create and hands back the id; the
 * route owns the page gutter and where its two exits lead — the dashboard that
 * now exists, which is where its tiles are placed, or the tab it was started
 * from.
 *
 * The landing arrives ARRANGING, with the add panel open: a dashboard created a
 * moment ago has no tiles, and a reader who has just named one is there to put
 * something on it. It travels as router state rather than as a search param
 * because it is a one-time invitation — a reload lands in view mode.
 */
function NewReportDashboardRoute() {
  const { t } = useTranslation("org");
  const navigate = useNavigate();
  const orgId = useAppStore((s) => s.activeOrgId);

  const backToDashboards = () => {
    void navigate({ to: "/reports", search: { tab: "dashboards" } });
  };

  if (!orgId) {
    return (
      <div className="p-8">
        <p className="text-muted">{t("noOrgContext")}</p>
      </div>
    );
  }

  return (
    <div className="p-8">
      <NewDashboardForm
        orgId={orgId}
        onCreated={(dashboardId) => {
          void navigate({
            to: "/reports/dashboards/$id",
            params: { id: dashboardId },
            state: { dashboardArrange: true },
          });
        }}
        onCancel={backToDashboards}
      />
    </div>
  );
}
